import { TYPES } from "./types";
import { sesProductService } from "../services";

export const getSESProducts = (query) => async (dispatch) => {
  try {
    console.log("getSESProducts @@@", query);
    const result = await sesProductService.getSESProducts(query);
    const data = result.data.data;

    console.log("getSESProducts @@@", data);
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_SES_PRODUCTS_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_SES_PRODUCTS_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const setSESProducts = (products, query = {}) => async (dispatch) => {
  try {
    const result = await sesProductService.setSESProducts(products, query);
    const data = result.data.data;
    
    if (data) {
      if (query.create_new) {
        dispatch({
          type: TYPES.ACTION_ADD_SES_PRODUCTS_SUCCESS,
          payload: { data }
        });
      } else if (query.generate_version) {
        dispatch({
          type: TYPES.ACTION_UPDATE_SES_PRODUCT_SUCCESS,
          payload: { data }
        });
      } else {
        dispatch({
          type: TYPES.ACTION_SET_SES_PRODUCTS_SUCCESS,
          payload: { data }
        });
      }

      // dispatch(getSESProducts({}));
    } else {
      dispatch({
        type: TYPES.ACTION_SET_SES_PRODUCTS_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getSESProductById = (id) => async (dispatch) => {
  try {
    const result = await sesProductService.getSESProductById(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_SES_PRODUCT_BY_ID_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_SES_PRODUCT_BY_ID_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createSESProduct = (product) => async (dispatch) => {
  try {
    const result = await sesProductService.createSESProduct(product);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_SES_PRODUCT_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_SES_PRODUCT_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateSESProduct = (id, product) => async (dispatch) => {
  try {
    const result = await sesProductService.updateSESProduct(id, product);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_SES_PRODUCT_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_SES_PRODUCT_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteSESProduct = (product) => async (dispatch) => {
  try {
    var { _id, product_code } = product;
    const result = await sesProductService.setSESProducts([{ _id,  product_code, is_deleted: true }]);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_DELETE_SES_PRODUCT_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_SES_PRODUCT_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getProductByVersion = (product_code, query) => async (dispatch) => {
  try {
    const result = await sesProductService.getProductByVersion(product_code, query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_SES_PRODUCTS_VERSION_SUCCESS,
        payload: { 
          product_code,
          data 
        }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_SES_PRODUCTS_VERSION_FAIL,
        payload: { product_code }
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const sesProductAction = {
  getSESProducts,
  setSESProducts,
  getSESProductById,
  createSESProduct,
  updateSESProduct,
  deleteSESProduct,
  getProductByVersion
}; 